export default __webpack_public_path__ + "static/media/history_24dp.45eb9bf8.svg";